<template>
  <div style="display:none;">
        <button class="btn-zip-code flex">
            <div class="location-pin"></div>
            <p>1880-083</p>
            <span class="arrow"></span>
        </button>
  </div>
</template>

<script>
export default {
    
}
</script>

<style>

</style>